<p *ngIf="mostrarCountdown" [ngClass]="labelClass ? labelClass : ''"  class="overflow-text-cover-2">
  <!-- Quedan {{ dias }} días, {{ horas }} hrs, {{ minutos }} min y {{ segundos }} s para completar tu curso -->

   <!-- Caso 1: Hay días restantes -->
   <!-- <span *ngIf="dias !== '00'">
     Quedan {{ dias }} día(s), {{ horas }} h, {{ minutos }} min y {{ segundos }} s para completar tu curso
    </span>
     -->
    <!-- Caso 2: No hay días pero sí horas -->
    <span >
      {{ horas }}:{{ minutos }}:{{ segundos }}
    </span>

  <!-- Caso 3: No hay días ni horas (siempre muestra minutos y segundos) -->
  <!-- <span *ngIf="dias === '00' && horas === '00'">
    Quedan {{ minutos }} min y {{ segundos }} s para completar tu curso
  </span> -->
</p>


